import { render, staticRenderFns } from "./pageElementRichtext.vue?vue&type=template&id=3a2447da&scoped=true&"
import script from "./pageElementRichtext.vue?vue&type=script&lang=js&"
export * from "./pageElementRichtext.vue?vue&type=script&lang=js&"
import style0 from "./pageElementRichtext.vue?vue&type=style&index=0&id=3a2447da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2447da",
  null
  
)

export default component.exports